import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/tr';
import 'moment/locale/ar';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { IAppState } from '../../models/action/core';
import Switch from 'react-switch';
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
    SortableContext,
    useSortable,
    arrayMove,
    rectSortingStrategy
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
const T = Translator.create();
const _common = new Common();

// Setting moment locale based on current language
moment.locale(T.i18next.language);

interface EducationModulesProps { }

interface EducationModulesState {
     activities: string[];
     draggingIndex: number | null;
}
function SortableItem(props: { id: string, name: string, icon: string }) {
     const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: props.id });

     const style = {
          transform: CSS.Transform.toString(transform),
          transition: undefined, // Animasyonu kaldırmak için transition'ı iptal ediyoruz
      };


     return (
         <div ref={setNodeRef} style={style} {...attributes} {...listeners} className="setting mini-line activity">
             <div className="d-flex align-items-center gap-1 flex-column">
                 <img src={props.icon} alt="" />
                 <span className="title">{props.name}</span>
             </div>
             <div className="specs">
                 <label className="switch">
                     <Switch
                         id={'check-autoEnroll'}
                         name={'autoEnroll'}
                         onChange={() => {}}
                         checked={true}
                         onColor="#358730"
                         onHandleColor="#358730"
                         handleDiameter={18}
                         uncheckedIcon={false}
                         checkedIcon={false}
                         boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                         activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                         height={20}
                         width={38}
                         className="react-switch"
                     />
                 </label>
             </div>
             <span className="move_btn">
                 <i className="material-icons">open_with</i>
             </span>
         </div>
     );
 }
class CEducationModule extends React.Component<EducationModulesProps, EducationModulesState> {
     activitiesMap: { [key: string]: string } = {
          assignment: `${T.t('r_activity_type_Assignment')}`,
          elesson: `${T.t('r_activity_type_Elesson')}`,
          survey: `${T.t('r_activity_type_Survey')}`,
          exam: `${T.t('r_activity_type_Exam')}`,
          document: `${T.t('r_activity_type_Document')}`,
          forum: `${T.t('r_activity_type_Forum')}`,
          video: `${T.t('r_activity_type_Video')}`,
          virtualClass: `${T.t('r_activity_type_VirtualClass')}`,
          LTIActivity: `${T.t('r_activity_type_LTIActivity')}`,
          informationNote: `${T.t('r_activity_type_InformationNote')}`,
          linkActivity: `${T.t('r_activity_type_LinkActivity')}`,
     };

     constructor(props: EducationModulesProps) {
          super(props);
          this.state = {
               activities: Object.keys(this.activitiesMap),
               draggingIndex: null,
          };
     }

     handleDragEnd = (event: any) => {
          const { active, over } = event;

          if (active.id !== over.id) {
              this.setState((prevState) => {
                  const oldIndex = prevState.activities.indexOf(active.id);
                  const newIndex = prevState.activities.indexOf(over.id);
                  return {
                      activities: arrayMove(prevState.activities, oldIndex, newIndex),
                  };
              });
          }
      };

     render() {
          const { activities, draggingIndex } = this.state;

          return (<>
          <div className="grid-32">
               <div>
               <DndContext collisionDetection={closestCenter} onDragEnd={this.handleDragEnd}>
                    <SortableContext items={activities} strategy={rectSortingStrategy}>
                        <div className="grid-4 settings-line gap-3">
                            {activities.map((key) => (
                                <SortableItem
                                    key={key}
                                    id={key}
                                    name={this.activitiesMap[key]}
                                    icon={_common.GetActivityTypeIcons(key)}
                                />
                            ))}
                        </div>
                    </SortableContext>
                </DndContext>
                    <div className="row px-4">
                         <div className='d-flex justify-content-end w-100 mt-4'>
                              <button className="btn btn-success" type='button'>{T.t("r_save_button")}</button>
                         </div>

                    </div>
               </div>
               <div className='px-4 grid-1 gap-1 py-3' style={{height:'calc(100vh - 72px)',overflowY:'auto'}}>
               {activities.map((key, index) => (
                         <div  key={index}>
                              <div className={'add_activity_list_btn module-explain '.concat(key.toLowerCase())} >
                                   <a className="d-flex justify-content-start align-items-center">
                                        <img
                                             className="ml-2 mr-3"
                                             style={{ width: '20px', height: '20px' }}
                                             src={_common.GetDefaultIcons('info')}
                                             alt={'Activity Icon'}
                                        />
                                        <div className="d-flex flex-column justify-content-start ">
                                             <span className="activity_explain_text">
                                                  {T.t('r_gen_enum_activity_' + key.charAt(0).toUpperCase() + key.slice(1))}
                                             </span>
                                             <span className="activity_explain">
                                                  {T.t('r_gen_enum_activity_exp_' +key.charAt(0).toUpperCase() + key.slice(1))}
                                             </span>
                                        </div>
                                   </a>
                              </div>
                         </div>
                         ))}
               </div>
          </div>
          </>
          );
     }
}



const EducationModule = CEducationModule;

export default EducationModule;
